import { Checkbox, FormItemProps } from 'antd';
import { CheckboxGroupProps, CheckboxOptionType } from 'antd/es/checkbox/Group';
import { FormItem } from 'src/components/Form/FormItem';
import { CssColors } from 'src/styles/CssVariables';
import styled from 'styled-components';

export type CheckboxGroupFieldProps = FormItemProps & {
    disabled?: boolean;
    inputProps?: CheckboxGroupProps;
    options?: (CheckboxOptionType | string | number)[];
};

export const CheckboxGroupField = ({
    disabled,
    inputProps,
    options,
    ...props
}: CheckboxGroupFieldProps) => {
    return (
        <FormItem {...props}>
            <StyledCheckboxGroup
                options={options}
                disabled={disabled}
                {...inputProps}
            />
        </FormItem>
    );
};

const StyledCheckboxGroup = styled(Checkbox.Group)`
    .ant-checkbox,
    .ant-checkbox:hover,
    .ant-checkbox:focus,
    .ant-checkbox:active {
        .ant-checkbox-inner,
        .ant-checkbox-checked::after {
            border-radius: 4px;
            border-color: ${CssColors.black} !important;
        }

        &.ant-checkbox-checked {
            .ant-checkbox-inner,
            .ant-checkbox-checked::after {
                background-color: ${CssColors.black} !important;
                border-color: ${CssColors.black} !important;
            }
        }
    }

    .ant-checkbox-checked,
    .ant-checkbox-checked:hover {
        &::after {
            border-color: ${CssColors.black};
            border-radius: 4px;
        }
    }
`;
